import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { VOICE_AI_URL } from '../../api/config';

const ProtectedRoute = () => {
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  const [shouldRedirectExternal, setShouldRedirectExternal] = useState(false);
  
  const restaurantId = localStorage.getItem('restaurantId');
  const accountId = localStorage.getItem('account_id');
  const token = localStorage.getItem('token');
  
  // Check authentication: Require restaurantId AND (accountId OR token)
  const isAuthenticated = restaurantId && (accountId || token);
  
  useEffect(() => {
    if (!isAuthenticated) {
      // Redirect to external Voice AI URL
      setShouldRedirectExternal(true);
      
      // Perform external redirect
      window.location.href = VOICE_AI_URL;
    } else {
      setIsChecking(false);
    }
  }, [isAuthenticated]);
  
  // Show loading or nothing while redirecting
  if (!isAuthenticated || shouldRedirectExternal) {
    return null;
  }
  
  // If still checking, show nothing
  if (isChecking) {
    return null;
  }
  
  // Render nested routes if authenticated
  return <Outlet />;
};

export default ProtectedRoute;
